<template>
  <div
    v-if="content"
    :class="['trial-strip', content.tone]"
    :style="offsetTop ? { top: offsetTop + 'px' } : null"
  >
    <div class="trial-strip-left">
      <svg
        class="trial-strip-icon"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <template v-if="content.tone === 'expired'">
          <rect x="3" y="11" width="18" height="11" rx="2" />
          <path d="M7 11V7a5 5 0 0110 0v4" />
        </template>
        <template v-else-if="content.tone === 'past-due'">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </template>
        <template v-else-if="content.tone === 'red'">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </template>
        <template v-else-if="content.ctaAction === 'resend-verification'">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
          <polyline points="22,6 12,13 2,6" />
        </template>
        <template v-else>
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </template>
      </svg>
      <div class="trial-strip-body" v-html="content.messageHtml"></div>
    </div>
    <div class="trial-strip-right">
      <button type="button" class="trial-strip-cta" @click="onCta">
        {{ content.ctaLabel }}
      </button>
      <button
        v-if="content.dismissible"
        type="button"
        class="trial-strip-dismiss"
        title="Dismiss"
        @click="$emit('dismiss')"
      >
        <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import './styles/TrialStrip.css'

export default {
  name: 'TrialStrip',
  props: {
    content: {
      type: Object,
      default: null
    },
    offsetTop: {
      type: Number,
      default: 0
    }
  },
  methods: {
    onCta: function () {
      this.$emit('cta', this.content && this.content.ctaHash ? this.content.ctaHash : '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// TrialStrip.vue?02d6635b